module.exports = __webpack_public_path__ + "static/img/search_off.5cb35878.svg";